"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.DraggableModalReducer = exports.getModalState = exports.setInitialModalStateZIndex = exports.initialModalState = exports.initialModalsState = void 0;

var _getWindowSize = require("./getWindowSize"),
    _clamp = require("./clamp");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      _defineProperty(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

function _toConsumableArray(a) {
  return _arrayWithoutHoles(a) || _iterableToArray(a) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(a) {
  if (Symbol.iterator in Object(a) || "[object Arguments]" === Object.prototype.toString.call(a)) return Array.from(a);
}

function _arrayWithoutHoles(a) {
  if (Array.isArray(a)) {
    for (var b = 0, c = Array(a.length); b < a.length; b++) {
      c[b] = a[b];
    }

    return c;
  }
} // eslint-disable-next-line no-irregular-whitespace

/* eslint-disable no-case-declarations */

/* eslint-disable no-shadow */


var mapObject = function mapObject(a, b) {
  return Object.assign.apply(Object, [{}].concat(_toConsumableArray(Object.keys(a).map(function (c) {
    return _defineProperty({}, c, b(a[c]));
  }))));
},
    initialModalsState = {
  maxZIndex: 0,
  windowSize: (0, _getWindowSize.getWindowSize)(),
  modals: {}
};

exports.initialModalsState = initialModalsState;
var initialModalState = {
  x: 0,
  y: 0,
  width: 800,
  height: 800,
  zIndex: 0,
  visible: !1
};
exports.initialModalState = initialModalState;

var setInitialModalStateZIndex = function setInitialModalStateZIndex(a) {
  initialModalState.zIndex = a, initialModalsState.maxZIndex = a;
};

exports.setInitialModalStateZIndex = setInitialModalStateZIndex;

var getModalState = function getModalState(a, b) {
  return a.modals[b] || initialModalState;
};

exports.getModalState = getModalState;

var getNextZIndex = function getNextZIndex(a, b) {
  return getModalState(a, b).zIndex === a.maxZIndex ? a.maxZIndex : a.maxZIndex + 1;
},
    clampDrag = function clampDrag(a, b, c, d, e, f) {
  var g = (0, _clamp.clamp)(0, a - e, c),
      h = (0, _clamp.clamp)(0, b - f, d);
  return {
    x: g,
    y: h
  };
},
    clampResize = function clampResize(a, b, c, d, e, f) {
  var g = (0, _clamp.clamp)(200, a - c, e),
      h = (0, _clamp.clamp)(200, b - d, f);
  return {
    width: g,
    height: h
  };
},
    DraggableModalReducer = function DraggableModalReducer(a, b) {
  switch (b.type) {
    case "resize":
      // eslint-disable-next-line no-case-declarations
      var h = clampResize(a.windowSize.width, a.windowSize.height, b.x, b.y, b.width, b.height);
      return _objectSpread({}, a, {
        maxZIndex: getNextZIndex(a, b.id),
        modals: _objectSpread({}, a.modals, _defineProperty({}, b.id, _objectSpread({}, a.modals[b.id], {}, h, {
          zIndex: getNextZIndex(a, b.id)
        })))
      });

    case "drag":
      return _objectSpread({}, a, {
        maxZIndex: getNextZIndex(a, b.id),
        modals: _objectSpread({}, a.modals, _defineProperty({}, b.id, _objectSpread({}, a.modals[b.id], {}, clampDrag(a.windowSize.width, a.windowSize.height, b.x, b.y, a.modals[b.id].width, a.modals[b.id].height), {
          zIndex: getNextZIndex(a, b.id)
        })))
      });

    case "show":
      {
        var c = a.modals[b.id],
            d = a.windowSize.width / 2 - c.width / 2,
            e = a.windowSize.height / 2 - c.height / 2,
            f = clampDrag(a.windowSize.width, a.windowSize.height, d, e, c.width, c.height),
            g = clampResize(a.windowSize.width, a.windowSize.height, f.x, f.y, c.width, c.height);
        return _objectSpread({}, a, {
          maxZIndex: a.maxZIndex + 1,
          modals: _objectSpread({}, a.modals, _defineProperty({}, b.id, _objectSpread({}, c, {}, f, {}, g, {
            zIndex: a.maxZIndex + 1,
            visible: !0
          })))
        });
      }

    case "focus":
      var i = a.modals[b.id];
      return _objectSpread({}, a, {
        maxZIndex: a.maxZIndex + 1,
        modals: _objectSpread({}, a.modals, _defineProperty({}, b.id, _objectSpread({}, i, {
          zIndex: a.maxZIndex + 1
        })))
      });

    case "hide":
      {
        var j = a.modals[b.id];
        return _objectSpread({}, a, {
          modals: _objectSpread({}, a.modals, _defineProperty({}, b.id, _objectSpread({}, j, {
            visible: !1
          })))
        });
      }

    case "mount":
      return _objectSpread({}, a, {
        maxZIndex: a.maxZIndex + 1,
        modals: _objectSpread({}, a.modals, _defineProperty({}, b.id, _objectSpread({}, initialModalState, {
          x: a.windowSize.width / 2 - initialModalState.width / 2,
          y: a.windowSize.height / 2 - initialModalState.height / 2,
          zIndex: a.maxZIndex + 1
        })))
      });

    case "unmount":
      var k = _objectSpread({}, a.modals);

      return delete k[b.id], _objectSpread({}, a, {
        modals: k
      });

    case "windowResize":
      return _objectSpread({}, a, {
        windowSize: b.size,
        modals: mapObject(a.modals, function (b) {
          if (!b.visible) return b;
          var c = clampDrag(a.windowSize.width, a.windowSize.height, b.x, b.y, b.width, b.height),
              d = clampResize(a.windowSize.width, a.windowSize.height, c.x, c.y, b.width, b.height);
          return _objectSpread({}, b, {}, c, {}, d);
        })
      });

    default:
      throw new Error();
  }
};

exports.DraggableModalReducer = DraggableModalReducer;